import React from "react";

import {Typography} from "@mui/material";
import {typografNode} from "../../utils/typograf";
import {SxProps} from "@mui/material/styles";

type P1Props = {
    children: React.ReactNode;
    className?: string;
    sx?: SxProps;
};

function P1({children, className, sx}: P1Props) {
    return (
        <Typography sx={{
            fontWeight: '400',
            fontFamily: 'Roboto, sans-serif',
            letterSpacing: 0,
            '@media screen and (min-width: 1400px)': {
                fontSize: '18px',
                lineHeight: 1.5,
            },
            '@media screen and (min-width: 1200px) and (max-width: 1399px)': {
                fontSize: '18px',
                lineHeight: 1.5,
            },
            '@media screen and (min-width: 768px) and (max-width: 1199px)': {
                fontSize: '16px',
                lineHeight: 1.5,
            },
            '@media screen and (min-width: 576px) and (max-width: 767px)': {
                fontSize: '14px',
                lineHeight: 1.5,
            },
            '@media screen and (max-width: 575px)': {
                fontSize: '14px',
                lineHeight: 1.5,
            },
            ...sx
        }} className={className}>
            {typografNode(children)}
        </Typography>
    );
}

export default P1;
